export enum EmailModalOrigin {
  CALENDAR_FILTER = 'CALENDAR_FILTER',
  OWNERS_PAGE = 'OWNERS_PAGE',
}
